const stats = [
  { value: "3x – 10x", label: "Return on Ad Spend", testid: "stat-roas" },
  { value: "50+", label: "Successful Campaigns", testid: "stat-campaigns" },
  { value: "$1M+", label: "In Ad Revenue Generated", testid: "stat-revenue" },
];

export default function Stats() {
  return (
    <section
      id="results"
      data-testid="stats-section"
      className="relative py-24 sm:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#FF5722]/40 to-transparent" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#FF5722]/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <div className="text-center mb-16">
          <div className="text-xs font-mono tracking-widest text-[#FF5722] uppercase mb-4">
            // Results
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white max-w-3xl mx-auto">
            Campaign Performance <span className="gradient-text">That Speaks</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={s.testid}
              className="text-center rounded-3xl bg-[#0c0c0c] border border-white/[0.06] p-10 hover:border-[#FF5722]/40 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="text-5xl sm:text-6xl md:text-7xl font-bold gradient-text tracking-tighter group-hover:scale-105 transition-transform">
                {s.value}
              </div>
              <div className="mt-5 text-sm text-zinc-400 tracking-wide uppercase font-mono">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
